import * as React from 'react'
import styled from 'styled-components'
import warning_white from '@/public/assets/icons/warning_white.svg'

interface IStyle {
    $width?: string
}

const Wrapper = styled.div<IStyle>`
    position: relative;
    width: ${(props) => (props.$width ? props.$width : '150px')};

    .tooltip_wrapper {
        opacity: 0;
        background-color: ${(props) => (props.color ? props.color : '#878787')};
        width: ${(props) => (props.$width ? props.$width : '200px')};
        display: flex;
        align-items: center;
        position: absolute;
        z-index: 1;
        top: -17px;
        left: 65%;
        border: transparent;
        border-radius: 5px;
        padding-top: 8px;
        padding-bottom: 12px;
        transition: opacity 0.3s;

        :after {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            width: 0;
            height: 0;
            border: 10px solid transparent;
            border-right-color: #878787;
            border-left: 0;
            margin-top: -12px;
            margin-left: -7px;
        }
    }
    :hover .tooltip_wrapper {
        opacity: 1;
    }
`

const Text = styled.div`
    font-family: Lato;
    font-size: 14px;
    color: #ffffff;
    padding-left: 20px;
    padding-right: 10px;
    text-transform: none;
`

const Logo = styled.img`
    width: 20px;
`

const LogoWrapper = styled.div`
    width: 20px;
    padding-right: 10px;
    padding-left: 10px;
`

type IProps = {
    width?: string
    text?: string
    children: React.ReactNode
    color?: string
    hasWarningIcon?: boolean
}

const Tooltip: React.FunctionComponent<IProps> = (props) => {
    return (
        <Wrapper $width={props.width}>
            <div className="tooltip_wrapper">
                {props.hasWarningIcon && (
                    <LogoWrapper>
                        <Logo src={warning_white.src} />
                    </LogoWrapper>
                )}
                <Text>{props.text ? props.text : 'No data'}</Text>
            </div>
            {props.children}
        </Wrapper>
    )
}

export default Tooltip
